import { useState } from "react";
import config from "config/config";
import moment from "moment/moment";
import { v4 as uuidv4 } from "uuid";
import Countdown from "react-countdown";
import { useForm } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";

import { registerUser } from "service/userservice/registerUser";
import { sendEmailNotification } from "service/notificationservice/sendEmailNotification";

import FormInputError from "components/General/FormInputError";
import DomainErrorModal from "components/ModalDialogs/DomainErrorModal";
import GeneralPurposeDialog from "components/General/GeneralPurposeDialog";
import RegistrationConfirmModal from "components/ModalDialogs/RegistrationConfirmModal";

import useTrackUnsuccessfulRegistration from "logging/hooks/useTrackUnsuccessfulRegistration";

const PanelFive = ({
  customerRegistrationFormData,
  setCustomerRegistrationFormData,
  setCurrentStep,
  setGeneratedPassCode,
  generatedPassCode,
  roleid,
  setLoading,
}) => {
  const { t } = useTranslation();
  const [modalState, setModalState] = useState(false);
  const [errorInfo, seterrorInfo] = useState("");
  const [modalErrorState, setModalErrorState] = useState(false);
  const [userEmail, setUserEmail] = useState(
    customerRegistrationFormData.email
  );
  const [userName, setUserName] = useState("");
  const [currentCounterTime, setCurrentCounterTime] = useState(
    Date.now() + parseInt(config.OTP_EXPIRY_TIME)
  );
  const [passcodeExpired, setPasscodeExpired] = useState(false);
  const [currentCounterIndex, setCurrentCounterIndex] = useState(0);
  const [
    unsuccessfulRegistrationModalState,
    setUnsuccessfulRegistrationModalState,
  ] = useState(false);

  const uuid = uuidv4();
  const {
    register: registrationPanelFourRegister,
    handleSubmit,
    formState: { errors: FivregistrationPanelFiveErrorse },
  } = useForm();

  const trackUnsuccessfulRegistration = useTrackUnsuccessfulRegistration();

  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const renderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      setPasscodeExpired(true);
      return (
        <p className="text-sm">{t("CustomerRegister-step-4-form-error-1")}</p>
      );
    } else {
      return (
        <p className="text-sm">{t("CustomerRegister-step-4-form-error-4")}</p>
      );
    }
  };

  async function resendCode() {
    let passcode = randomNumberInRange(100000, 999999);
    setGeneratedPassCode(passcode.toString());
    setLoading(true);
    let securitycode = randomNumberInRange(100000, 999999);
    let sec =
      parseInt(securitycode.toString().substring(3, 4)) === 0
        ? 1
        : parseInt(securitycode.toString().substring(3, 4));
    let confirmationcode = passcode * sec;
    let contentDictionary = {};
    contentDictionary.confirmationcode = confirmationcode.toString();
    contentDictionary.username = userName;
    contentDictionary.securitycode = securitycode.toString();
    await sendEmailNotification(userEmail, 2, contentDictionary).catch(
      (error) => {
        console.error(error);
      }
    );
    setLoading(false);
    setCurrentCounterTime(Date.now() + parseInt(config.OTP_EXPIRY_TIME));
    setCurrentCounterIndex(currentCounterIndex + 1);
    setPasscodeExpired(false);
  }

  async function onSubmit(formData) {
    setCustomerRegistrationFormData((curr) => ({ ...curr, ...formData }));
    let data = customerRegistrationFormData;
    setUserEmail(data.email);
    setUserName(
      data.policyOwnerType === "individual" ? data.firstname : data.businessName
    );
    if (passcodeExpired) {
      seterrorInfo(t("CustomerRegister-step-4-form-error-1"));
      setModalErrorState(true);
    } else {
      if (
        formData.registrationConfirmationCode === generatedPassCode ||
        (config.ENABLE_DEFAULT_OTP === "true" &&
          formData.registrationConfirmationCode === config.DEFAULT_OTP)
      ) {
        let UserSecurityQADto = [];
        const SA1 = {
          QuestionId: parseInt(data.securityQuestionOne),
          UserAnswer: data.securtityAnswerOne.replaceAll(/\s/g, ""),
        };
        UserSecurityQADto.push(SA1);

        const SA2 = {
          QuestionId: parseInt(data.securityQuestionTwo),
          UserAnswer: data.securtityAnswerTwo.replaceAll(/\s/g, ""),
        };
        UserSecurityQADto.push(SA2);

        const SA3 = {
          QuestionId: parseInt(data.securityQuestionThree),
          UserAnswer: data.securtityAnswerThree.replaceAll(/\s/g, ""),
        };
        UserSecurityQADto.push(SA3);

        let optedPaperLess = 0;
        let notificationPreference = 1;

        if (data.paperless === "yes") {
          optedPaperLess = 1;
        } else if (data.paperless === "both") {
          optedPaperLess = 2;
        } else {
          optedPaperLess = 0; //no
        }

        if (data.notificationMethod === "email") {
          notificationPreference = 1;
        } else {
          notificationPreference = 2;
        }

        let updateEmailFlag = data.userEmail !== data.email;
        let updateEmailOption = data.defaultpaperless !== data.paperless;

        setLoading(true);
        await registerUser(
          data.oldPolicyId,
          data.contractId,
          data.policyOwnerType === "individual"
            ? data.firstname
            : data.businessName,
          data.lastname,
          data.identityNumber,
          data.zipCode,
          data.phoneNumber,
          optedPaperLess,
          notificationPreference,
          data.email,
          data.username,
          data.hashedPassword.toString(),
          roleid,
          UserSecurityQADto,
          data.dob ? moment(data.dob).format("MM/DD/YYYY") : null,
          updateEmailFlag,
          updateEmailOption,
          data.ownerType,
          data.taxType
        ).then((res) => {
          setLoading(false);

          if (res.ok) {
            setModalState(true);
          } else {
            setUnsuccessfulRegistrationModalState(true);
            trackUnsuccessfulRegistration({
              oldPolicyId: data.oldPolicyId,
              contractId: data.contractId,
              firstName:
                data.policyOwnerType === "individual"
                  ? data.firstname
                  : data.businessName,
              lastName: data.lastname,
              zipCode: data.zipCode,
              phoneNumber: data.phoneNumber,
              optedPaperLess,
              notificationPreference,
              email: data.email,
              username: data.username,
              roleid,
              UserSecurityQADto,
              insuredDob: moment(data.insuredDob).format("MM/DD/YYYY"),
              updateEmailFlag,
              updateEmailOption,
              ownerType: data.ownerType,
            });
          }
        });
      } else {
        seterrorInfo(t("CustomerRegister-step-4-form-error-2"));
        setModalErrorState(true);
      }
    }
  }
  return (
    <>
      <form
        className="pt-4 mt-2 lg:pt-6 border-t border-theme-rule-medium"
        onSubmit={handleSubmit(onSubmit)}
      >
        <p className="text-sm">{t("CustomerRegister-step-4-form-label-1")}</p>
        <div className="mt-4">
          <label id={`${uuid}-confirmationCodeLabel`}>
            {t("CustomerRegister-step-4-form-label-3")}
          </label>
          <input
            id="ID_confirmationCode"
            className="w-full"
            type="text"
            aria-labelledby={`${uuid}-confirmationCodeLabel`}
            {...registrationPanelFourRegister("registrationConfirmationCode", {
              required: {
                value: true,
                message: t("CustomerRegister-step-4-form-error-3"),
              },
              pattern: {
                value: /^\d{6}$/,
                message: t("CustomerRegister-step-4-form-error-1"),
              },
            })}
          />
          {FivregistrationPanelFiveErrorse.registrationConfirmationCode && (
            <FormInputError
              id={`${uuid}-registrationConfirmationCodeError`}
              errorMessage={
                FivregistrationPanelFiveErrorse.registrationConfirmationCode
                  .message
              }
            />
          )}
        </div>
        <div className="mt-4 md:mt-6">
          <Countdown
            date={currentCounterTime}
            key={currentCounterIndex}
            renderer={renderer}
          />
        </div>
        <div className="mt-4 text-right">
          <button
            type="button"
            className="ui-btn-secondary ui-btn-min-w mt-2"
            onClick={() => setCurrentStep(4)}
          >
            <Trans
              i18nKey="CustomerRegister-step-2-form-button-1"
              components={{
                srText: <span className="sr-only"></span>,
              }}
            ></Trans>
          </button>
          <button
            className="ui-btn-secondary ui-btn-min-w mt-2"
            type="button"
            onClick={() => resendCode()}
          >
            {t("CustomerRegister-step-4-form-button-1")}
          </button>
          <button type="submit" className="ui-btn-primary ui-btn-min-w mt-2">
            {t("CustomerRegister-step-4-form-button-2")}
          </button>
        </div>
      </form>
      <RegistrationConfirmModal
        modalState={modalState}
        setModalState={setModalState}
      />
      <DomainErrorModal
        modalState={modalErrorState}
        setModalState={setModalErrorState}
        errorInfo={errorInfo}
      />

      <GeneralPurposeDialog
        state={unsuccessfulRegistrationModalState}
        setState={setUnsuccessfulRegistrationModalState}
        title={t("CustomerRegister-panel-four-title")}
        desc={t("CustomerRegister-panel-four-desc")}
        showCloseButton={false}
      />
    </>
  );
};

export default PanelFive;
